import moment from "moment";

import { CreateSharingScheduleBody } from "../apis";
import { SharingScheduleFormValues } from "../components";
import { SharingScheduleRules } from "../constants";

export const convertSharingScheduleFormDataToCreateRequestBody = (
  formData: SharingScheduleFormValues
): CreateSharingScheduleBody => {
  const fromDate = Array.isArray(formData.dateRange) && formData.dateRange[0];
  const toDate = Array.isArray(formData.dateRange) && formData.dateRange[1];

  return {
    name: formData.name,
    from: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
    to: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
    numberOfProducts: +formData.numberOfProducts,
    rule: formData.rule,
    ruleTimeframe: formData.ruleTimeframe,
    ruleTimeNumber: +formData.ruleTimeNumber,
    productVariantIds:
      formData.rule === SharingScheduleRules.ManualSelectionOfProducts
        ? formData.productVariants.map(({ id }) => id)
        : undefined
  };
};
